/**
 * Module dependencies.
 */

import React, { useCallback } from 'react';
import styles from '../sales-list.module.less';
import { CrudTemplate, WrapperWidget } from 'app/components/organisms/crud/form-types';
import { Language } from 'app/types/language';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { Button } from 'app/components/atoms/button/button';
import { useTranslation } from 'react-i18next';
import { range } from 'lodash';
import { CrudFormRender } from 'app/components/organisms/crud/crud-form';
import classNames from 'classnames';
import { saleItemsFormField } from './form-sale-items-config';

/**
 * `Props` type.
 */

type Props<T> = {
  children: JSX.Element;
  template: CrudTemplate<T>;
  languages: Language[];
  currentLanguage: string | undefined;
  mainLanguage: string | undefined;
  metadata: any;
  formType: 'add' | 'edit';
  name: string;
  item: WrapperWidget;
  form: UseFormReturn<FieldValues, any>;
};

/**
 * Export `SaleItemsForm` component.
 */

export function SaleItemsForm<T>({ ...rest }: Props<T>): JSX.Element {
  const [translate] = useTranslation();

  const formFields = useCallback(
    (index: number) => {
      return saleItemsFormField(translate, `lines[${index}]`);
    },
    [translate]
  );

  const lines = rest.form.getValues('lines') ?? [];

  return (
    <div className={styles.posologiesForm}>
      {range(lines.length).map(index => {
        const deletedAt = lines[index]?.deletedAt;

        return (
          <div className={classNames(styles.addWrapper, styles.level1)} key={index}>
            <div className={styles.wrapperHeader}>
              {deletedAt && '[DELETED] '}

              {'Sale Item: '}
              {index + 1}
            </div>

            <CrudFormRender {...rest} formFields={formFields(index)} />
          </div>
        );
      })}

      <div className={classNames(styles.orderItemHeader)}>
        <div>
          <Button
            onClick={() => {
              rest.form.setValue('lines', [...lines, {}]);
            }}
            type={'primary'}
          >
            {translate('users.sales.add.actions.addOrderItem')}
          </Button>
        </div>

        {lines.length > 0 && (
          <div>
            <Button
              danger
              disabled={lines === 0}
              onClick={() => {
                const newLines = lines.slice(0, lines.length - 1);

                rest.form.setValue('lines', newLines);
              }}
            >
              {translate('users.sales.add.actions.removeLine')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
